// 判断返回数据是否为空
// php 无论是对象还是数组为空都会默认返回 []
export function isEmpty(data) {
  if (!data || (data instanceof Array && data.length === 0)) {
    return null;
  }
  return data;
}

// 判断当数值前是上涨还是下跌
export function checkRiseOrFall(str) {
  if (!str) return '';
  return str.indexOf('-') !== -1 ? 'fall' : 'rise';
}

// 分转换成元
export function converFenToYuan(number) {
  if (!number) return 0;
  return parseInt(number, 10) / 100;
}
